import { motion } from "framer-motion";

// TODO: Convert to typescript

export default function CircleLoader() {
  const containerStyle = {
    position: "relative",
    width: "2rem",
    height: "2rem",
    boxSizing: "border-box",
  };

  const circleStyle = {
    display: "block",
    width: "2rem",
    height: "2rem",
    border: "0.5rem solid #fdfdfd",
    borderTop: "0.5rem solid #ee582b",
    borderRadius: "50%",
    position: "absolute",
    boxSizing: "border-box",
    top: 0,
    left: 0,
  };

  const spinTransition = {
    loop: Infinity,
    ease: "linear",
    duration: 1,
  };

  return (
    <div style={containerStyle}>
      <motion.span
        style={circleStyle}
        animate={{ rotate: 360 }}
        transition={spinTransition}
      />
    </div>
  );
}
